module.exports = __webpack_public_path__ + "static/media/1.c5965443.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_138/images/buy/1.png
// module id = 1294
// module chunks = 0